import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {DisplaySmaller} from '../primitives/display';
import './style.css';

export const Box = (props) => {
    const classNames = [
        'box',
        props.isCentered ? 'is-centered' : '',
        props.footer ? 'has-footer' : '',
        props.slimHeader ? 'slim-header' : '',
        props.isBlured ? 'is-blured' : '',
        props.className
    ];

    return (
        <div className={classNames.join(' ')} style={props.style}>
            {props.title ? (
                <DisplaySmaller>{props.title} <Subtitle>{props.subtitle}</Subtitle></DisplaySmaller>
            ) : null}

            {props.children}

            {props.footer ? (
                <div className="box-footer">
                    {props.footer}
                </div>
            ) : null}
        </div>
    );
};

Box.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.array
    ]),
    style: PropTypes.object,
    className: PropTypes.string,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    subtitle: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    isCentered: PropTypes.bool,
    isBlured: PropTypes.bool,
    slimHeader: PropTypes.bool,
    footer: PropTypes.element
};

Box.defaultProps = {
    style: {},
    className: '',
    title: null,
    subtitle: '',
    isCentered: false,
    footer: null,
    slimHeader: false
};

const Subtitle = styled.span`
    color: #696969;
    font-size: 14px;
    line-height: 16px;
    margin-left: 4px;
    float: right;
    font-weight: 500;
    float: right;
`;

export default Box;
